<style lang="less" rel="stylesheet/less" scoped>

</style>
<template>
    <div v-if="item">
        <div v-if="item.subquest_list">
            <QuestionItem ref="sub" :item="subItem" v-for="subItem in item.subquest_list"></QuestionItem>
        </div>
        <div v-else>
            <QuestionTypeInput ref="sub" :item="item" v-if="isInput(item)"></QuestionTypeInput>
            <QuestionTypeSelect ref="sub" :item="item" v-if="isSelect(item)"></QuestionTypeSelect>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import QuestionTypeInput from './QuestionTypeInput.vue';
    import QuestionTypeSelect from './QuestionTypeSelect.vue';
    import {QUESTION_TYPE} from '../lib/const';

    export default {
        name:'QuestionItem',
        props:['item'],
        data() {
            return {}
        },
        computed: {},
        methods: {
            isInput(item){
                return item.type === QUESTION_TYPE.INPUT;
            },
            isSelect(item){
                return item.type === QUESTION_TYPE.SELECT || item.type === QUESTION_TYPE.MULTI_SELECT;
            },
            checkValid(){
                return this.$refs.sub.checkValid();
            }
        },
        components: {QuestionTypeInput,QuestionTypeSelect},
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// QuestionItem.vue?3c9ba0cc